import React from "react";
import Layout from "./src/components/common/index";
// import ShopProvider from "./src/context/shopContext";
import "./src/styles/global.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { initCaching } from "./src/utils/serviceWorker";

const GATSBY_SPACER_IMAGE_SELECTOR =
  'img[aria-hidden="true"][role="presentation"][alt=""][src^="data:image/svg+xml"]';

const removeAriaHiddenFromGatsbySpacers = () => {
  if (typeof document === "undefined") return;

  document
    .querySelectorAll(GATSBY_SPACER_IMAGE_SELECTOR)
    .forEach((image) => {
      image.removeAttribute("aria-hidden");
      image.dataset.gatsbySpacerA11y = "true";
    });
};

export const wrapPageElement = ({ element, props }) => {
  return (
    // <ShopProvider>
    <Layout location={props.location}>{element}</Layout>
    // </ShopProvider>
  );
};

// Initialize caching when the app is ready
export const onClientEntry = () => {
  removeAriaHiddenFromGatsbySpacers();

  // Initialize service worker and caching
  if (typeof window !== "undefined") {
    if ("MutationObserver" in window) {
      const observer = new MutationObserver(removeAriaHiddenFromGatsbySpacers);
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    }

    // Wait for the page to load to ensure service worker doesn't
    // impact initial page load performance
    window.addEventListener("load", () => {
      removeAriaHiddenFromGatsbySpacers();
      initCaching();
    });
  }
};

export const onRouteUpdate = () => {
  removeAriaHiddenFromGatsbySpacers();
};

export function shouldUpdateScroll({
  routerProps: { location },
  getSavedScrollPosition,
}) {
  const state = location?.state;
  if (state?.disableScrollUpdate) {
    return false;
  }

  const animationDuraion = 0.3;
  const scrollDelay = animationDuraion * 1000;

  if (location.action === "PUSH") {
    window.setTimeout(() => window.scrollTo(0, 0), scrollDelay);
  } else {
    const savedPosition = getSavedScrollPosition(location);
    window.setTimeout(() => window.scrollTo(...[0, 0]), scrollDelay);
  }

  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }

  return false;
}
